import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { MENU_ITEMS } from '../../config/menu'

const Menu = () => {
  const location = useLocation()
  const { t } = useTranslation()

  const isActiveRoute = (route: string) => {
    const currentPathSegments = location.pathname.split('/').filter(Boolean)
    const routeSegments = route.split('/').filter(Boolean)

    return currentPathSegments[0] === routeSegments[0]
  }

  return (
    <nav className="h-full p-6 bg-gray-200 border-r border-gray-100 flex flex-col justify-between">
      <ul className="list-none space-y-2 mb-6">
        {MENU_ITEMS.map(({ route, title, icon }) => {
          const isActive = isActiveRoute(route)

          return (
            <li key={route}>
              <Link
                to={route}
                className={`block p-2 pl-5 rounded text-left ${
                  isActive ? 'bg-blue-500 text-white' : 'hover:bg-gray-300'
                }`}
              >
                <img
                  src={icon}
                  alt=""
                  className={`inline-block mr-2 w-5 h-5 ${
                    isActive ? 'filter invert' : ''
                  }`}
                />
                {t(title)}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Menu
